import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin/tenants` → redirige a `/admin/organizaciones`. La lista de cuentas se consolidó en
 * Organizaciones (misma data + tipo de organización, productos contratados, impersonación y acceso
 * al detalle). El detalle individual sigue vivo en `/admin/tenants/$id`.
 */
export const Route = createFileRoute('/_authenticated/admin/tenants/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/organizaciones' });
  },
});
